import {
  beEmailMessageApiGetMessageDetailsLazy,
  beEmailMessageSearchMessages
} from 'Api/beEmailMessageApi'
import memo from 'Helpers/memo'
import { storeGet, STORE_KEY_ID_LIST } from 'mailup-react-helpers'

export const MESSAGE_SELECT_MAX_ITEMS = 700

const makeMessageItem = ({ Id, Subject, IsBee }) => ({
  label: `${Id} - ${Subject}`,
  value: Id,
  isBee: IsBee
})

async function fetchMessagesList(searchString) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const { Items, TotalItems } = await beEmailMessageSearchMessages(
    idList,
    {
      pageNumber: 1,
      pageSize: MESSAGE_SELECT_MAX_ITEMS,
      orderBy: 'Id',
      orderDescending: false
    },
    {
      SearchText: searchString,
      FullText: false,

      Tags: [],
      Status: 'NotArchived',
      ServiceTypes: [0, 3],
      MessageTypes: ['Generic', 'Welcome', 'Confirmation']
    }
  )

  return {
    items: Items.map((o) => makeMessageItem(o)),
    totalItems: TotalItems
  }
}

export const getMemoMessagesList = memo(fetchMessagesList)

export async function fetchMessageDetailsById(idMessage) {
  const result = await beEmailMessageApiGetMessageDetailsLazy(idMessage)
  return result ? makeMessageItem(result) : null
}
